var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { id: "deviceedit" } },
    [
      _c(
        "v-card",
        { attrs: { "max-width": "800px" } },
        [
          _c("v-card-title", [_vm._v(_vm._s(_vm.title))]),
          _c(
            "v-card-text",
            [
              _c(
                "v-form",
                { ref: "form" },
                [
                  _c("v-text-field", {
                    attrs: { label: _vm.$t("deviceEdit.name") },
                    model: {
                      value: _vm.model.name,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "name", $$v)
                      },
                      expression: "model.name"
                    }
                  }),
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t("deviceEdit.hardware-unique-id"),
                      readonly: "",
                      disabled: ""
                    },
                    model: {
                      value: _vm.model.deviceID,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "deviceID", $$v)
                      },
                      expression: "model.deviceID"
                    }
                  }),
                  _c("v-select", {
                    attrs: {
                      label: _vm.$t("deviceEdit.operationMode"),
                      items: _vm.operationModes
                    },
                    on: { change: _vm.validate },
                    model: {
                      value: _vm.model.config.operationMode,
                      callback: function($$v) {
                        _vm.$set(_vm.model.config, "operationMode", $$v)
                      },
                      expression: "model.config.operationMode"
                    }
                  }),
                  _vm.model.config.operationMode === "kiosk" &&
                  !_vm.anonymousAllowed
                    ? _c("p", [
                        _vm._v(
                          " " + _vm._s(_vm.$t("deviceEdit.lock-to-user")) + " "
                        )
                      ])
                    : _vm._e(),
                  _vm.model.config.operationMode === "kiosk" &&
                  _vm.anonymousAllowed
                    ? _c("p", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("deviceEdit.lock-to-user-optional")) +
                            " "
                        )
                      ])
                    : _vm._e(),
                  _vm.model.config.operationMode === "kiosk"
                    ? _c("v-select", {
                        attrs: {
                          items: _vm.contentLocalised,
                          "item-text": "title",
                          "item-value": "uid",
                          label: _vm.$t("deviceEdit.content")
                        },
                        on: { change: _vm.validate },
                        model: {
                          value: _vm.model.config.session.content,
                          callback: function($$v) {
                            _vm.$set(_vm.model.config.session, "content", $$v)
                          },
                          expression: "model.config.session.content"
                        }
                      })
                    : _vm._e(),
                  _vm.model.config.operationMode === "kiosk"
                    ? _c("v-select", {
                        attrs: {
                          label: _vm.$t("deviceEdit.learner"),
                          items: _vm.users
                        },
                        on: { change: _vm.validate },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "item",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  _vm._v(" " + _vm._s(item.displayName) + " ")
                                ]
                              }
                            },
                            {
                              key: "selection",
                              fn: function(ref) {
                                var item = ref.item
                                return [
                                  _vm._v(" " + _vm._s(item.displayName) + " ")
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1944111964
                        ),
                        model: {
                          value: _vm.kioskUser,
                          callback: function($$v) {
                            _vm.kioskUser = $$v
                          },
                          expression: "kioskUser"
                        }
                      })
                    : _vm._e(),
                  _vm.model.config.operationMode === "normal"
                    ? _c("v-switch", {
                        attrs: {
                          label: _vm.$t("deviceEdit.unlockCheckpoints")
                        },
                        model: {
                          value: _vm.model.config.unlockCheckpoints,
                          callback: function($$v) {
                            _vm.$set(_vm.model.config, "unlockCheckpoints", $$v)
                          },
                          expression: "model.config.unlockCheckpoints"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1" },
                  on: { click: _vm.cancel }
                },
                [_vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { disabled: !_vm.valid, color: "success" },
                  on: { click: _vm.submit }
                },
                [_vm._v(" " + _vm._s(_vm.$t("global.save")) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }